<div class="table-fms height-unset overflow-x-auto">
  <table>
    <thead>
    <tr>
      <th class="text-left width-1p85">
        <app-three-dots-menu  [matMenuTriggerFor]="menu"></app-three-dots-menu>
        <mat-menu #menu="matMenu">
          <ul class="list">
            <app-drop-down-item class="width-100pcnt"
              data-qa="excel"
              [text]="'Export'"
              [iconNameAndStyling]="'excel.svg'"
              (click)="exportExcel()">
            </app-drop-down-item>
          </ul>
        </mat-menu>
      </th>
      <th class="text-left">
       <div class="w-full h-full flex items-center gap-0.3125">
          <app-funds-selector-dropdown
            data-qa="org-pp-funds-selector-dropdown"
            [(selectedFundsAmount)]="selectedFundsAmount"
            [(fundsData)]="fundsData"/>
          <span appSort
            [arr]="[fundOverview]"
            [keySelector]="sortPpFund.byFundName">
          </span>
        </div>
      </th>
      <th class="text-left fix-w-7p5"
        appSort
        [arr]="[fundOverview]"
        [keySelector]="sortPpFund.byPeriod">Reporting period
      </th>
      <th class="text-left fix-w-7p5"
        appSort
        [arr]="[fundOverview]"
        [keySelector]="sortPpFund.byInvestment">Investment
      </th>
      <th class="text-left fix-w-7p5"
        appSort
        [arr]="[fundOverview]"
        [keySelector]="sortPpFund.byFairValue">Fair value
      </th>
      <th class="text-left fix-w-7p5"
        appSort
        [arr]="[fundOverview]"
        [keySelector]="sortPpFund.byGainLoss">Gain/(loss)
      </th>
      <th class="text-left fix-w-7p5"
        appSort
        [arr]="[fundOverview]"
        [keySelector]="sortPpFund.byMoic">MOIC
      </th>
      <th class="text-left fix-w-7p5"
        appSort
        [arr]="[fundOverview]"
        [keySelector]="sortPpFund.byIrr">IRR
      </th>
      <th class="text-left fix-w-7p5"
        appSort
        [arr]="[fundOverview]"
        [keySelector]="sortPpFund.byHolding">Holding
      </th>
      <th class="text-left fix-w-7p5">Company value</th>
    </tr>
    </thead>

    <tbody>
    <ng-container *ngIf="fundOverview === undefined">
      <tr *ngFor="let i of [].constructor(selectedOrg?.funds?.length)"
          app-table-empty-state
          class="animation-wrapper"
          [tdAmount]="10">
      </tr>
    </ng-container>
    <ng-container *ngFor="let o of fundOverview">
      <ng-container *ngIf="o.isShown">
      <tr>
        <td class="text-left" [class.border-shadow-left]="o.isOpened">
          <app-table-group-icon
            [opened]="o.isOpened"
            (click)="o.isOpened = !o.isOpened">
          </app-table-group-icon>
        </td>
        <td class="text-left bold600">

          <div class="start-row-container row-gap-0p375">
            <span class="company-name" (click)="goToFund(o)">{{o.fundName}}</span>
            <app-circle-badge-count [count]="o.overview.companiesAmount"></app-circle-badge-count>
          </div>
        </td>
        <td class="text-left">{{o.overview.selectedFundPeriod}} </td>
        <td class="text-left">{{o.overview.total?.investment  | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
        <td class="text-left">{{o.overview.total?.fairValue | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
        <td class="text-left">{{o.overview.total?.fairValue - o.overview.total?.investment | numberswitcher:switcher:0 | dashInsteadOfNull | negativeValueToBraces}}</td>
        <td class="text-left"
            *ngVar="o.overview.total?.moic as moic">{{moic ? 'x' + (moic | number: '1.2-2') : '-'}}</td>
        <td class="text-left" *ngVar="o.overview.total?.irr as irr">
          {{irr  * 100 | prefixSuffix: '': '%': true}}
        </td>
        <td class="text-left"></td>
        <td class="text-left"></td>
      </tr>
      <ng-container *ngIf="o.isOpened">
        <ng-container *ngFor="let i of ['active', 'sold']">
          <tr *ngIf="o.overview[i].ppsLength">
            <ng-container *ngVar="o.overview[i].total as fundTotal">
              <td class="text-left" [class.border-shadow-left]="o.isOpened"></td>
              <td class="text-left bold600">
                <div  class="start-row-container row-gap-0p375">
                  <app-table-group-icon
                    [opened]="o.overview[i].isOpened"
                    (click)="o.overview[i].isOpened = !o.overview[i].isOpened">
                  </app-table-group-icon>
                  {{i === 'active' ? 'Active' : 'Realized'}}
                  <app-circle-badge-count [count]="o.overview[i].ppsLength"></app-circle-badge-count>
                </div>
              </td>
              <td class="text-left"></td>
              <td class="text-left">{{fundTotal.investment  | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
              <td class="text-left">{{fundTotal.fairValue | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
              <td class="text-left">{{fundTotal.fairValue - fundTotal.investment | numberswitcher:switcher:0 | dashInsteadOfNull | negativeValueToBraces}}</td>
              <td class="text-left" *ngVar="fundTotal.moic as moic">{{moic ? 'x' + (moic | number: '1.2-2') : '-'}}</td>
              <td class="text-left" *ngVar="fundTotal.irr as irr">
                {{irr * 100 | prefixSuffix: '': '%': true}}
              </td>
              <td class="text-left"></td>
              <td class="text-left"></td>
            </ng-container>
          </tr>
          <ng-container *ngIf="o.overview[i].ppsLength && o.overview[i].isOpened">
            <ng-container *ngFor="let c of o.overview[i].pps">
              <tr *ngIf="c.selectedPP">
                <td class="text-left" [class.border-shadow-left]="o.isOpened"></td>
                <td>
                  <span class="width-fit-content bold600 company-name text-left pd-l-2" (click)="goToCompanyPerformance(c.company.id, o)">{{c.selectedPP.name}}</span>
                </td>
                <td class="text-left"></td>
                <td
                  class="text-left">{{c.selectedPP.investment | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
                <td class="text-left">{{c.selectedPP.fairValue | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
                <td class="text-left">{{c.selectedPP.fairValue - c.selectedPP.investment | numberswitcher:switcher:0 | dashInsteadOfNull | negativeValueToBraces}}</td>
                <td class="text-left"
                    *ngVar="c.selectedPP.moic as moic">{{moic ? 'x' + (moic | number: '1.2-2') : '-'}}</td>
                <td class="text-left" *ngVar="c.selectedPP.irr as irr">
                  {{irr * 100 | prefixSuffix: '': '%': true}}
                </td>
                <td class="text-left">{{c.selectedPP.holding * 100 | prefixSuffix: '': '%': true}}</td>
                <td
                  class="text-left">{{c.selectedPP.companyValue | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

      </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="total">
      <tr class="grand-total">
        <td class="text-left"></td>
        <td class="text-left bold600">Total</td>
        <td class="text-left"></td>
        <td
          class="text-left">{{total.investment | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
        <td class="text-left">{{total.fairValue | numberswitcher:switcher:0 | dashInsteadOfNull}}</td>
        <td class="text-left">{{total.fairValue - total.investment | numberswitcher:switcher:0 | dashInsteadOfNull | negativeValueToBraces}}</td>
        <td class="text-left">{{total.moic
          | number: '1.2-2' | prefixSuffix: 'x': '': true | negativeValueToBraces}}</td>
        <td class="text-left"></td>
        <td class="text-left"></td>
        <td
          class="text-left"></td>

      </tr>
    </ng-container>
    </tbody>
  </table>
</div>
